'use client';

import classNames from 'classnames';
import * as React from 'react';

export interface TextareaProps extends React.TextareaHTMLAttributes<any> {
  label?: string;
  labelClassName?: string;
  error?: string;
}

const Textarea = React.forwardRef<any, TextareaProps>(
  ({ className, maxLength, label, labelClassName, error, ...props }, ref) => {
    const internalRef = React.useRef<any>(null);

    // function to get value length
    const getValueLength = () => {
      return internalRef.current?.value.length || 0;
    };

    return (
      <div className="flex flex-col gap-2">
        {/* Label */}
        {label && (
          <label className={classNames('text-sm font-medium text-white', labelClassName)}>
            {label}
          </label>
        )}

        <div className="relative w-full">
          <textarea
            ref={(el) => {
              // Assign to both internal and external refs
              internalRef.current = el;
              if (typeof ref === 'function') {
                ref(el);
              } else if (ref) {
                ref.current = el;
              }
            }}
            className={classNames(
              'min-h-32 w-full rounded-2xl px-3 py-2 text-sm outline-0 transition-all ease-in-out',
              'bg-white placeholder:font-light placeholder:text-neutral-500',
              'shadow-6 outline-white disabled:cursor-not-allowed disabled:opacity-50',
              {
                'border-2 border-red-500': error,
              },
              className
            )}
            {...props}
          />

          {maxLength && (
            <div
              className={classNames('absolute right-3 bottom-2 text-[10px] text-neutral-600', {
                'text-text-red': props['aria-invalid'],
              })}>
              {getValueLength()}/{maxLength}
            </div>
          )}
        </div>

        {/* Error Message */}
        {error && <p className="mt-1 text-sm text-red-500">{error}</p>}
      </div>
    );
  }
);

Textarea.displayName = 'Textarea';

export { Textarea };
